import { redirect } from "react-router-dom";
import {createBrowserHistory} from "history";
// history = createBrowserHistory()
const AuthLogout = () => {
	localStorage.clear();
	window.location.replace('/auth');

}

export default AuthLogout;